import API from "@/api/lib/api";

export const getAllTeaCoffees = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/tea-coffees`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleTeaCoffee = async (item_id) => {
  try {
    const response = await API.get(`restaurant/tea-coffees/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createTeaCoffee = async (data) => {
  try {
    const response = await API.post(`restaurant/tea-coffees`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateTeaCoffee = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/tea-coffees/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteTeaCoffee = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/tea-coffees/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};